import Vue from 'vue'
import Router from 'vue-router'
import authMiddleware from './middlewares/auth'
import guestMiddleware from './middlewares/guest'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ '@/views/home')
    },
    {
      path: '/register',
      name: 'register',
      component: () =>
        import(/* webpackChunkName: "register" */ '@/views/register'),
      beforeEnter: guestMiddleware
    },
    {
      path: '/login',
      name: 'login',
      components: {
        default: () => import(/* webpackChunkName: "home" */ '@/views/home'),
        dialog: () =>
          import(/* webpackChunkName: "login" */ '@/components/modals/Login')
      }
    },
    {
      path: '/password/email',
      name: 'password.email',
      components: {
        default: () => import(/* webpackChunkName: "home" */ '@/views/home'),
        dialog: () =>
          import(
            /* webpackChunkName: "password-reset" */ '@/components/modals/ForgotPassword'
          )
      }
    },
    {
      path: '/password/reset',
      name: 'password.reset',
      components: {
        default: () => import(/* webpackChunkName: "home" */ '@/views/home'),
        dialog: () =>
          import(
            /* webpackChunkName: "password-reset" */ '@/components/modals/PasswordReset'
          )
      }
    },
    {
      path: '/onboard',
      name: 'onboard',
      component: () =>
        import(/* webpackChunkName: "onboarding" */ '@/views/onboard'),
      beforeEnter: guestMiddleware
    },
    {
      path: '/edit-profile',
      name: 'edit-profile',
      component: () =>
        import(/* webpackChunkName: "edit-profile" */ '@/views/profile/Edit'),
      beforeEnter: authMiddleware
    },
    {
      path: '/my-notifications',
      name: 'my-notifications',
      component: () =>
        import(
          /* webpackChunkName: "my-notifications" */ '@/views/notifications'
        ),
      beforeEnter: authMiddleware
    },
    {
      path: '/my-messages',
      name: 'my-messages',
      component: () =>
        import(
          /* webpackChunkName: "my-messages" */ '@/views/notifications/messages'
        ),
      beforeEnter: authMiddleware
    },
    /**
     * Groups
     */
    {
      path: '/groups',
      name: 'groups',
      component: () => import(/* webpackChunkName: "groups" */ '@/views/group'),
      beforeEnter: authMiddleware
    },
    {
      path: '/groups/my',
      name: 'groups.details',
      component: () =>
        import(/* webpackChunkName: "groups" */ '@/views/group/Group'),
      beforeEnter: authMiddleware
    },
    {
      path: '/groups/edit',
      name: 'groups.edit',
      component: () =>
        import(/* webpackChunkName: "groups" */ '@/views/group/Edit'),
      beforeEnter: authMiddleware
    },
    {
      path: '/groups/noticeboard',
      name: 'groups.noticeboard',
      component: () =>
        import(/* webpackChunkName: "groups" */ '@/views/group/Noticeboard'),
      beforeEnter: authMiddleware
    },
    {
      path: '/groups/onboard',
      name: 'groups.onboard',
      component: () =>
        import(/* webpackChunkName: "groups" */ '@/views/group/Onboard'),
      beforeEnter: guestMiddleware
    },
    {
      path: '/groups/:slug',
      name: 'groups.show',
      component: () =>
        import(/* webpackChunkName: "groups" */ '@/views/group/Group'),
      beforeEnter: authMiddleware
    },
    /**
     * News
     */
    {
      path: '/news',
      name: 'news',
      component: () => import(/* webpackChunkName: "news" */ '@/views/news')
    },
    {
      path: '/news/:slug',
      name: 'news.view',
      component: () =>
        import(/* webpackChunkName: "news" */ '@/views/news/View')
    },
    /**
     * Resources
     */
    {
      path: '/resources',
      name: 'resources',
      component: () =>
        import(/* webpackChunkName: "resources" */ '@/views/resources'),
      beforeEnter: authMiddleware
    },
    {
      path: '/resources/:slug',
      name: 'resources.view',
      component: () =>
        import(/* webpackChunkName: "resources" */ '@/views/resources/View'),
      beforeEnter: authMiddleware
    },
    {
      path: '/resources/:slug/:course',
      name: 'resources.course',
      component: () =>
        import(/* webpackChunkName: "resources" */ '@/views/resources/Course'),
      beforeEnter: authMiddleware
    },
    /**
     * Student Training
     */
    {
      path: '/training',
      name: 'training',
      component: () =>
        import(/* webpackChunkName: "training" */ '@/views/training'),
      beforeEnter: authMiddleware
    },
    {
      path: '/training/blogs/:slug',
      name: 'training.blogs.view',
      component: () =>
        import(/* webpackChunkName: "training" */ '@/views/training/blog/View')
    },
    {
      path: '/training/resources/:slug',
      name: 'training.resources.view',
      component: () =>
        import(
          /* webpackChunkName: "training" */ '@/views/training/resources/View'
        )
    },
    {
      path: '/training/resources/:slug/:course',
      name: 'training.resources.course',
      component: () =>
        import(
          /* webpackChunkName: "training" */ '@/views/training/resources/Course'
        ),
      beforeEnter: authMiddleware
    },
    /**
     * Student Hub
     */
    {
      path: '/student-hub',
      name: 'student-hub',
      component: () =>
        import(/* webpackChunkName: "student" */ '@/views/student'),
      beforeEnter: authMiddleware
    },
    {
      path: '/student-hub/:id',
      name: 'student-hub.view',
      component: () =>
        import(/* webpackChunkName: "student" */ '@/views/student/Post'),
      beforeEnter: authMiddleware
    },
    {
      path: '*',
      name: 'errors.404',
      component: () =>
        import(/* webpackChunkName: "student" */ '@/views/errors/404')
    }
  ]
})
